// extracted by mini-css-extract-plugin
export default {"container":"Alert_container__x6HhN","title":"Alert_title__Zc-3o","content":"Alert_content__AgRRa","closeButton":"Alert_closeButton__OIcde"};